import React from 'react';
import { List, useTable, ShowButton } from '@refinedev/antd';
import { Table, Tag, Space } from 'antd';
import { MoodLogDto, MoodLevel } from '@wellverse/shared-ts';

const moodColors: Record<MoodLevel, string> = {
  [MoodLevel.AWFUL]: '#ff6b6b',
  [MoodLevel.BAD]: '#fa8c16',
  [MoodLevel.OKAY]: '#fadb14',
  [MoodLevel.GOOD]: '#52c41a',
  [MoodLevel.GREAT]: '#1890ff',
};

const moodEmojis: Record<MoodLevel, string> = {
  [MoodLevel.AWFUL]: '😢',
  [MoodLevel.BAD]: '😔',
  [MoodLevel.OKAY]: '😐',
  [MoodLevel.GOOD]: '🙂',
  [MoodLevel.GREAT]: '😄',
};

export const MoodLogList: React.FC = () => {
  const { tableProps } = useTable<MoodLogDto>({
    resource: 'mood-logs',
    pagination: { current: 1, pageSize: 20 },
  });

  return (
    <List resource="mood-logs">
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="userId" title="User ID" />
        <Table.Column
          dataIndex="mood"
          title="Mood"
          render={(mood: MoodLevel) => (
            <Tag
              style={{
                borderColor: moodColors[mood] || '#898989',
                color: moodColors[mood] || '#898989',
                background: `${moodColors[mood] || '#898989'}15`,
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {moodEmojis[mood]} {mood}
            </Tag>
          )}
        />
        <Table.Column
          dataIndex="energy"
          title="Energy"
          render={(energy: number | undefined) =>
            energy !== undefined ? `${energy}/5` : '—'
          }
        />
        <Table.Column
          dataIndex="stress"
          title="Stress"
          render={(stress: number | undefined) =>
            stress !== undefined ? `${stress}/5` : '—'
          }
        />
        <Table.Column
          dataIndex="sleep"
          title="Sleep"
          render={(sleep: number | undefined) =>
            sleep !== undefined ? `${sleep}/5` : '—'
          }
        />
        <Table.Column
          dataIndex="notes"
          title="Notes"
          render={(notes: string | undefined) =>
            notes ? (notes.length > 30 ? `${notes.slice(0, 30)}...` : notes) : '—'
          }
        />
        <Table.Column
          dataIndex="loggedAt"
          title="Logged At"
          render={(date: string) => (date ? new Date(date).toLocaleString() : '—')}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: MoodLogDto) => (
            <Space>
              <ShowButton hideText size="small" recordItemId={record.id} resource="mood-logs" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};